var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"auto","overflow":"hidden"}},[_c('video',{style:({height:_vm.datas.style.h + 'px',width:100 + '%'}),attrs:{"src":_vm.datas.style.url,"controls":"controls"}})])}
var staticRenderFns = []

export { render, staticRenderFns }